/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
 */
export interface PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  name?: string | null;
  /**
   *
   * @type {CredentialRead}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant
   */
  assistantId: string;
}

/**
 * Check if a given object implements the PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant interface.
 */
export function instanceOfPatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant(
  value: object,
): value is PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSON(
  json: any,
): PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  return PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped(
    json,
    false,
  );
}

export function PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
  };
}

export function PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantToJSON(
  value?: Omit<
    PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant,
    'id' | 'credential'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
  };
}
